import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[scrollToTop]',
  standalone: false,
})
export class ScrollToTopDirective {

  @HostListener('click')
  onClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
} 